"use client";

import type { FC } from "react";

import { Faq as FaqUI } from "@jti/ui/components/Faq";

import type { faqInputs } from "./Faq.builder";

export type FaqProps = BuilderComponentProps<typeof faqInputs>;

export const Faq: FC<FaqProps> = ({
  additionalHelp,
  showAdditionalHelp,
  title,
  additionalHelpEmail,
  details,
  detailsLink,
  faqList,
}) => {
  return (
    <FaqUI
      additionalHelpText={additionalHelp}
      showAdditionalHelp={showAdditionalHelp}
      title={title}
      additionalHelpEmail={additionalHelpEmail}
      details={details}
      detailsLink={detailsLink}
      faqList={faqList}
    />
  );
};
